<template>
  <v-container
    id="login"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="primary"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                <v-icon left>
                  mdi-account-off
                </v-icon>
                Déconnexion
                <v-icon right>
                  mdi-account-off
                </v-icon>
              </h1>
            </div>
          </template>

          <v-card-text class="text-center">
            Vous avez été déconnecté.
            <br><br>
            Vous allez être redirigé dans {{ remainingTime }}
            <template v-if="remainingTime > 1">
              secondes.
            </template>
            <template v-else>
              seconde.
            </template>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'Logout',

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        countDown: {
          timerInit: 3000,
          steps: 1000,
          timer: 0,
        },
      }
    },

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    computed: {
      remainingTime: function () {
        return this.countDown.timer / 1000
      },
    },

    /* Hook : fonction appelée juste après que l’instance ait été créée */
    created: function () {
      this.$Auth.logout()
      this.beginTimer()
      window.setTimeout(() => {
        this.$router.replace({ name: 'Login' })
      }, this.countDown.timerInit)
    },

    /* Fonctions internes */
    methods: {
      beginTimer: function () {
        this.initTimer()
        this.countDownTimer()
      },

      countDownTimer () {
        if (this.countDown.timer > 0) {
          window.setTimeout(() => {
            this.countDown.timer -= this.countDown.steps
            this.countDownTimer()
          }, this.countDown.steps)
        } else {
          this.resetTimer()
        }
      },

      initTimer () {
        this.countDown.timer = this.countDown.timerInit
      },

      resetTimer () {
        this.countDown.timer = 0
      },
    },
  }
</script>
